import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  from,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { toast } from "react-toastify";
import { ToastTemplate } from "../variables";
import { getCookie } from "../generic.methods";
import config from "@/config";

const errorLink = onError(({ graphqlErrors, networkError }) => {
  if (graphqlErrors) {
    graphqlErrors.map(({ message, location, path }) => {
      toast.error(ToastTemplate.error(message));
    });
  }
});

// Add the authorization token to the GraphQL header
const authLink = setContext((_, { headers }) => {
  // Get the authorization token from wherever it is stored (e.g., localStorage, state, etc.)
  const token = headers?.authorization ?? getCookie("CRM-Auth");
  const companyKey = headers?.companyKey ?? getCookie("companyKey");

  // Return the headers object with the authorization token added
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      companyKey: companyKey,
    },
  };
});

const link = from([errorLink, new HttpLink({ uri: config.graphQLUrl })]);
const report_link = from([
  errorLink,
  new HttpLink({ uri: config.reportGraphQLUrl }),
]);

export const GqlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(
    ApolloLink.split(
      (operation) => operation.getContext().clientName === "report",
      report_link, //if above
      link
    )
  ),
});
